import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import roomPlaceholder from '@/img/hotel_page/room_placeholder.png';

import { IconChevron, IconPhotos } from './Rm3Icons';

/** Container photos (spec §1.2): prev/next wrap around, count badge at inline-end, click opens room details. */
function Rm3PhotoCarousel({ images, alt, onOpen }) {
    const { t } = useTranslation();
    const [index, setIndex] = useState(0);
    const count = images.length;
    const current = count ? images[index % count] : roomPlaceholder;

    const step = (delta) => (event) => {
        event.stopPropagation();
        setIndex((previous) => (previous + delta + count) % count);
    };

    return (
        <div className="rm3-photo">
            <img
                className={`rm3-photo__image${onOpen ? ' rm3-photo__image--clickable' : ''}`}
                src={current}
                alt={alt}
                onClick={onOpen || undefined}
                data-testid="rm3-room-photo"
            />
            {count > 1 && (
                <>
                    <button
                        type="button"
                        className="rm3-photo__nav rm3-photo__nav--prev"
                        aria-label={t('HotelDealsRm3.PreviousImage')}
                        onClick={step(-1)}
                        data-testid="rm3-photo-prev"
                    >
                        <IconChevron className="rm3-chevron rm3-chevron--back" />
                    </button>
                    <button
                        type="button"
                        className="rm3-photo__nav rm3-photo__nav--next"
                        aria-label={t('HotelDealsRm3.NextImage')}
                        onClick={step(1)}
                        data-testid="rm3-photo-next"
                    >
                        <IconChevron className="rm3-chevron" />
                    </button>
                </>
            )}
            {count > 0 && (
                <div
                    className="rm3-photo__count"
                    aria-label={t('HotelDealsRm3.PhotoCount', { count })}
                    data-testid="rm3-photo-count"
                >
                    <IconPhotos />
                    <span dir="ltr">{count}</span>
                </div>
            )}
        </div>
    );
}

export default Rm3PhotoCarousel;
